import dayjs from 'dayjs';
import {
  CalendarEvent,
  CalendarEventShowAs,
  MealType,
  defaultEventCategorySet,
} from '@demind-inc/core';
import { ChatSuggestedEvent } from '../data-access';

export const transformChatSuggestedEventToCalendarEvent = (
  event: ChatSuggestedEvent,
  unSyncToCalendar?: boolean,
  showAs?: CalendarEventShowAs
): Partial<CalendarEvent> => {
  const scheduleFrom = ['aiScheduler', 'sleep', 'todo', 'meal'].includes(
    event.autoScheduleFrom?.from!
  )
    ? event.autoScheduleFrom?.from
    : undefined;

  // Convert categoryId to categories array if present
  const categories = event.categoryId
    ? [defaultEventCategorySet.find(({ id }) => id === event.categoryId)].filter((cat) => !!cat)
    : undefined;

  return {
    eventId: event.eventId,
    summary: event.name,
    start: {
      date: event.startTime,
      timeZone: dayjs.tz.guess(),
    },
    end: {
      date: event.endTime,
      timeZone: dayjs.tz.guess(),
    },
    description: event.description,
    autoScheduleFrom: event.autoScheduleFrom,
    taskFrom: event.taskFrom,
    scheduleFrom,
    ...(categories && categories.length > 0 && { categories }),
    ...(event.recurrence?.string
      ? {
          recurrence: {
            string: event.recurrence.string,
          },
        }
      : {}),
    ...(unSyncToCalendar !== undefined && { unSyncToCalendar }),
    ...(showAs !== undefined && { showAs }),
    ...(event.location?.trim() ? { location: event.location.trim() } : {}),
  };
};

export const findCTAType = (event: ChatSuggestedEvent): 'sleep' | 'meal' | 'todo' | 'calendar' => {
  if (event.autoScheduleFrom?.from === 'sleep') {
    return 'sleep';
  } else if (event.autoScheduleFrom?.from === 'meal') {
    return 'meal';
  } else if (event.autoScheduleFrom?.from === 'todo') {
    return 'todo';
  }
  return 'calendar';
};
